import { ButtonProps as ButtonLibProps } from '@ui-kitten/components';

export type ButtonProps = Omit<ButtonLibProps, 'status'> & {
	variant?: 'filled' | 'outline' | 'link';
	color?: 'primary' | 'basic' | 'danger';
	children: string | React.ReactNode;
	loading?: boolean;
};
